import createInstance from "./interceptors";
const API_URL = process.env.VUE_APP_API_BASE_URL + "/api";

class ConfigService {
  getStatusSystem() {
    const instance = createInstance();

    return instance.get(API_URL + "/maintenance").then((response) => {
      return response.data;
    });
  }
}
export default new ConfigService();
